import { styled, Typography } from '@mui/material';

const StyledNotificationDate = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  display: 'block',
  fontVariantNumeric: 'tabular-nums',
  marginTop: theme.spacing(0.5)
}));

export default StyledNotificationDate;
